import './fileUploadLimit.scss';
import React, { useEffect } from "react"
import ErrorIcon from 'assets/icons/icon-network-error.svg';
import { translateText } from '../../../getTranslationsMyProfileUploadDocumentation';
import { recordLinkV2 } from "utilities/tagging"

export const FileUploadLimit = ({processSelected}) => {
    useEffect(() => {
        recordLinkV2({
            categoriaEvento: `documentos/subida de documentacion/${processSelected}`,
            accionEvento: "subir archivo/error",
            categoriaError: `error en subida de documentacion/${processSelected}`,
            descripcionError: "solo se pueden adjuntar 6 archivos en esta operativa"
        })
    },[])

  return (
      <div className="file-upload-limit">
          <img src={ErrorIcon} alt="Error" />
          <p>{translateText('maxFilesAdvise')}</p>
      </div>
  );
};
